// constants
import { showSuccessAlert } from "../../constants/alerts";
import { FooterActionTypes } from "./constants";

const INIT_STATE = {
  contents: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface footerData {
  id: string;
  footer_en: string;
  footer_ar: string;
}

interface FooterActionType {
  type:
    | FooterActionTypes.API_RESPONSE_SUCCESS
    | FooterActionTypes.API_RESPONSE_ERROR
    | FooterActionTypes.CREATE_FOOTER
    | FooterActionTypes.UPDATE_FOOTER
    | FooterActionTypes.GET_FOOTER
    | FooterActionTypes.DELETE_FOOTER;
  payload: {
    actionType?: string;
    data?: footerData | {};
    error?: string;
    contents?: [];
  };
}

interface State {
  contents?: footerData[] | [];
  loading?: boolean;
  value?: boolean;
}

const Footer = (
  state: State = INIT_STATE,
  action: FooterActionType
): any => {
  switch (action.type) {
    case FooterActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case FooterActionTypes.CREATE_FOOTER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case FooterActionTypes.GET_FOOTER: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            contents: action.payload.data,
          };
        }
        case FooterActionTypes.UPDATE_FOOTER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case FooterActionTypes.DELETE_FOOTER: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case FooterActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case FooterActionTypes.CREATE_FOOTER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case FooterActionTypes.UPDATE_FOOTER: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case FooterActionTypes.GET_FOOTER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case FooterActionTypes.DELETE_FOOTER: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case FooterActionTypes.CREATE_FOOTER:
      return { ...state, loading: true };
    case FooterActionTypes.UPDATE_FOOTER:
      return { ...state, loading: true };
    case FooterActionTypes.GET_FOOTER:
      return { ...state, loading: true, initialLoading: true };
    case FooterActionTypes.DELETE_FOOTER:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default Footer;
